import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { SubCategoryForm } from "@univdiam/ui/customComponents/SubCategoryList/SubCategoryForm"
import api from '@/http/api'

export default function EditSubCategory() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState(null)

  useEffect(() => {
    const fetchSubCategory = async () => {
      try {
        const response = await api.get(`/api/subcategory/${id}`)
        if (response.status === 200 && response.data) {
          const category = response.data.data
          console.log(category)
          // Map fields to your form shape
          setInitialData({
            sub_category_id: category.sub_category_id,
            category_id: category.category_id,
            name: category.name,
            code: category.code,
            status: category.status === 1 ? "1" : "0"  
          })
        }
      } catch (err) {
        console.error("Failed to fetch category", err)
        alert("Error fetching category.")
        navigate("/sub-category")
      }
    }

    fetchSubCategory()
  }, [id, navigate])

  const handleUpdateSubCategory = async (data: any) => {
    try {
      const response = await api.put(`/api/subcategory/${id}`, data)
      if (response.status === 200) {
        alert("SubCategory updated successfully!")
        navigate("/sub-category")
      }
    } catch (error) {
      console.error("Error updating category:", error)
      alert("Failed to update category.")
    }
  }

  if (!initialData) return <p className="text-center p-10">Loading...</p>

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit SubCategory</h1>
      <SubCategoryForm onSubmit={handleUpdateSubCategory} initialValues={initialData} isEdit />
    </div>
  )
}
